<template>
  <div class="demo__padding-top--10 demo__padding-bottom--10 animated fadeIn">
    <div
      class="demo__text-center demo__font--24 demo__weight--600 demo__text-left-mobile demo__font-mobile--18 demo__width-mobile-230"
    >
      <span class="demo__inline demo__color--black">
        {{ subsModalStatus?.title }}
      </span>
    </div>
    <a-row
      class="demo__margin-top--15 demo__margin-top-mobile--0"
      type="flex"
      align="stretch"
    >
      <a-col
        :xl="8"
        :lg="12"
        :md="12"
        :sm="24"
        :xs="24"
        v-for="(plan, index) in subsModalStatus?.list"
        :key="plan.id"
      >
        <a-spin :spinning="plan.id === loading">
          <VerticalObjectBlock
            class="demo__text-center demo__margin-mobile-0 demo__margin-top-mobile--20 demo__height-full"
            :object="plan"
            :no-image="true"
            :is-slot="true"
            :height="isMobile ? 'auto' : height"
            :demo="!plan.id"
            :padding="isMobile ? 5 : 4"
            margin-type="base"
            bg="white"
            color="black"
            :border="index === 1 ? 'gradient' : 'bgDescription'"
            :desc="false"
          >
            <div
              v-if="plan.id"
              class="demo__flex demo__flex-column demo__height-full"
            >
              <div
                class="demo__font--20 demo__weight--600 demo__font-mobile--16 demo__color--black"
              >
                {{ plan.title }}
              </div>
              <div
                class="demo__margin-top--30 demo__color--black demo__margin-top-mobile--16"
              >
                <span
                  class="demo__font--32 demo__font-mobile--18 demo__weight--600"
                >
                  {{
                    formatNumberString(plan.amount) +
                    " " +
                    (plan.currency?.symbol || "-")
                  }}
                </span>
              </div>
              <a-button
                class="demo__button demo__button--full demo__margin-top--30 demo__margin-bottom--30"
                v-bind:class="{
                  'demo__button--gradient': index === 1,
                  'demo__button--gray': index !== 1,
                }"
                @click="subsModalStatus.callback(plan.id)"
              >
                {{ $t("buy") }}
              </a-button>
              <div>
                <div
                  v-for="feature in plan.benefits"
                  :key="feature.id"
                  class="demo__flex demo__flex-top demo__text-left demo__margin-top--16"
                >
                  <i
                    class="fa-solid fa-check demo__color--brandPrimary demo__font--16 demo__margin-right--8"
                  ></i>
                  <span class="demo__font--16 demo__weight--400">
                    {{ feature.title }}
                  </span>
                </div>
              </div>
            </div>
          </VerticalObjectBlock>
        </a-spin>
      </a-col>
    </a-row>
    <a-row v-if="extInfo" type="flex" justify="space-around" align="middle">
      <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
        <div
          class="demo__flex demo__flex-between demo__flex-column-mobile demo__text-left-mobile demo__BubbleBlock--col"
          v-bind:class="{
            'demo__flex-middle': !isMobile,
          }"
        >
          <!-- <div class="demo__margin-top-mobile--10 demo__width-full">
            <a-input
              class="demo__input"
              :placeholder="$t('Subs.EnterPromo')"
              v-model="promo"
            ></a-input>
          </div> -->
        </div>
      </a-col>
      <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
        <div
          class="demo__font--16 demo__weight--500 demo__underline demo__pointer demo__margin-top-mobile--10 demo__BubbleBlock--col demo__text-center demo__text-left-mobile demo__color--black"
        >
          <!-- {{ $t("Subs.PlansDesc") }} -->
        </div>
      </a-col>
      <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
        <div
          class="demo__font--16 demo__weight--500 demo__underline demo__pointer demo__margin-top-mobile--10 demo__BubbleBlock--col demo__text-right demo__text-left-mobile demo__color--black"
        >
          <a
            :href="userLinks.userAgreement"
            target="_blank"
            class="demo__color--black"
            >{{ $t("Subs.Offer") }}
          </a>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import VerticalObjectBlock from "Components/VerticalObjectBlock";

export default {
  props: {
    isModal: {
      type: Boolean,
      required: false,
      default: true,
    },
    height: {
      required: false,
      default: 538,
    },
    extInfo: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  components: {
    VerticalObjectBlock,
  },
  data() {
    return {
      promo: undefined,
      loading: false,
      corpRequested: false,
    };
  },
  computed: {
    ...mapGetters([
      "api",
      "user",
      "subsPlans",
      "userIsBaseSub",
      "isMobile",
      "userLinks",
      "userIsCorpSub",
      "subsModalStatus",
    ]),
  },
  watch: {
    corpRequested() {
      window?.localStorage.setItem("corpRequested", true);
    },
  },
  beforeDestroy() {
    this.$root.$off("changeSubLoading", this.changeSubLoading);
  },
  created() {
    this.$accessModule("subs", this);
    this.$root.$on("changeSubLoading", this.changeSubLoading);
  },
  methods: {
    formatNumberString(input) {
      if (!input) return "";
      // Remove any existing formatting or spaces
      let numStr = input.replace(/[ ,]/g, "");

      // Split into integer and decimal parts
      let parts = numStr.split(".");
      let integerPart = parts[0];

      // Add thousand separators
      let formatted = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ");

      return formatted;
    },
    changeSubLoading(loading) {
      this.loading = loading;
    },
    async goToPlansPage() {
      await this.$store.dispatch("updateSubsModalStatus", false);
      this.$router.push("/subscriptions");
    },
  },
};
</script>
